import { QueryObserverResult, useQuery } from '@tanstack/react-query';
import { useSetRecoilState } from 'recoil';

import {
  API_QUERY_KEYS,
  getConsulteePermission,
  GetConsulteePermissionResponse,
  PermissionsQueryDefaults,
} from 'api';
import {
  consulteeEmailState,
  consulteeIdState,
  consulteeNameState,
  consulteeOrganisationIdsState,
  consulteeParentOrganisationIdsState,
  isAdminState,
  isConsulteeState,
  isTQAdminState,
} from 'store';
import { Permission } from 'types';

export const useConsulteePermission = (
  isAuthenticated: boolean
): QueryObserverResult<GetConsulteePermissionResponse> => {
  const setConsulteeId = useSetRecoilState(consulteeIdState);
  const setName = useSetRecoilState(consulteeNameState);
  const setEmail = useSetRecoilState(consulteeEmailState);
  const setOrganisationIds = useSetRecoilState(consulteeOrganisationIdsState);
  const setParentOrganisationIds = useSetRecoilState(consulteeParentOrganisationIdsState);
  const setIsAdmin = useSetRecoilState(isAdminState);
  const setIsConsultee = useSetRecoilState(isConsulteeState);
  const setIsTQAdmin = useSetRecoilState(isTQAdminState);

  return useQuery([API_QUERY_KEYS.getConsulteePermission], getConsulteePermission, {
    ...PermissionsQueryDefaults,
    onSuccess(response: GetConsulteePermissionResponse) {
      setConsulteeId(response.consulteeId);
      setName(response.name);
      setEmail(response.email);
      setOrganisationIds(response.organisationIds);
      setParentOrganisationIds(response.parentOrganisationIds);
      setIsAdmin(response.permission === Permission.Admin);
      setIsConsultee(response.permission === Permission.Consultee);
      setIsTQAdmin(response.permission === Permission.TQAdmin);
    },
    enabled: isAuthenticated,
  });
};
